module.exports = __webpack_public_path__ + "static/media/ico_tint_max.6f15298a.svg";